<script>
import UtilsMixin from "@/mixins/utils";

export default {
  components: {},
  props: {
    listItem: Array,
    distributor: Object,
    me: Object,
    shipper: Object,
    salesman: Object
  },
  data() {
    return {
      timePrint: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() >= 10 ? new Date().getMonth() + 1 : `0${new Date().getMonth() + 1}`,
        day: new Date().getDate() >= 10 ? new Date().getDate() : `0${new Date().getDate()}`,
        hour: new Date().getHours(),
        min: new Date().getMinutes(),
        sec: new Date().getSeconds(),
      },
    }
  },
  mixins: [UtilsMixin],
  computed: {
    totalAmount() {
      return this.listItem.reduce((totalAmount, item) => {
        return totalAmount +  parseFloat(item.amount) + parseFloat(item.amount_vat)
      }, 0);
    }
  }
};
</script>

<template>
  <div class="page">
    <div class="d-flex justify-content-between">
      <div>
        <p class="text-uppercase mb-2 font-size-16">{{ distributor.distributor_name }}</p>
        <p class="text-uppercase mb-2 font-size-16">Địa chỉ: {{ distributor.distributor_address }}</p>
        <p class="text-uppercase mb-0 font-size-16">Tel: {{ distributor.distributor_phone }}</p>
      </div>
    </div>
    <h2 class="text-uppercase text-center pt-3">Phiếu xuất hàng theo hàng hoá</h2>
    <p class="text-center">Ngày: {{ timePrint.day }}/{{ timePrint.month }}/{{ timePrint.year }} {{
        timePrint.hour
      }}:{{ timePrint.min }}:{{ timePrint.sec }}</p>
    <div class="print-content">
      <p class="font-size-16">Nhân viên: {{ me.name }} {{ me.phone ? `- ${me.phone}` : "" }}</p>
      <p v-if="shipper && shipper.email" class="font-size-16">Giao hàng: {{ shipper.email }}</p>
      <p v-if="salesman" class="font-size-16">Salesman: {{ salesman }}</p>
    </div>
    <table class="table table-bordered font-size-16 border-black">
      <thead>
      <tr>
        <th>STT</th>
        <th>Mã</th>
        <th>Tên</th>
        <th style="min-width: 140px">Số lượng</th>
        <th>Đơn giá</th>
        <th>Chiết khấu</th>
        <th>VAT (%)</th>
        <th>Thành tiền</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, key) of listItem" :key="key">
        <td>{{ key + 1 }}</td>
        <td>{{ item.ids_sku }}</td>
        <td>{{ item.item_name }}</td>
        <td>
          <p class="mb-1">{{ item.export_qty }} {{ item.unit_name }}</p>
          <template v-if="item.extra_data">
            <div v-for="(unit, index) of item.extra_data" :key="index">
              <p class="text-muted" :class="index + 1 !== item.extra_data ? 'mb-0' : 'mb-1'">
                ({{ unit.description }})
              </p>
            </div>
          </template>
        </td>
        <td>{{ formatPrice(item.price) }}</td>
        <td>{{ formatPrice(item.discount_amount) }}</td>
        <td>{{ item.vat }}</td>
        <!-- <td>{{ formatPrice(item.amount) }}</td> -->
        <td>{{ item.amount_vat ? formatPrice(item.amount + item.amount_vat) : formatPrice(item.amount) }}</td>
      </tr>
      <tr>
        <td colspan="7"><b>Tổng tiền</b></td>
        <td colspan="7">{{ formatPrice(totalAmount) }}</td>
      </tr>
      </tbody>
      <tfoot class="footer-repeat no-border">
         <!-- add repeated tfoot for extra space -->
         <tr class="no-border">
            <td class="no-border">&nbsp;</td>
         </tr>
      </tfoot>
    </table>
    <div class="print-footer d-flex justify-content-around font-size-16 pt-3">
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">Người nhận hàng</p>
        <p class="font-italic text-center">(Ký, họ tên)</p>
      </div>
      <div>
        <p>Ngày {{ timePrint.day }} tháng {{ timePrint.month }} năm {{ timePrint.year }}</p>
        <p class="font-weight-medium text-center mb-0">Thủ kho</p>
        <p class="font-italic text-center">(Ký, họ tên)</p>
      </div>
    </div>
  </div>
</template>
